import { createAction, props } from '@ngrx/store'
import { ContactModel, RequestModel, ResponseModel, ResultBulkAddModel } from '@models/index'

export const searchContactsByLocation = createAction(
    '[Contacs Page] Search Contact By Location',
    props<{ pages: { page: number, size: number } }>()
)

export const searchContactsSuccess = createAction(
    '[Contacs Page] Search Contact By Location Success',
    props<{ total: number, data: ContactModel[] }>()
)

export const searchContactsByQueryByLocation = createAction(
    '[Contacs Page] Search Contact By Query By Location',
    props<{ payload: { page: number, size: number, query: string } }>()
)

export const searchContactsByBusiness = createAction(
    '[Contacs Page] Search Contact By Business',
    props<{ pages: { page: number, size: number } }>()
)

export const searchContactsByQueryByBusiness = createAction(
    '[Contacs Page] Search Contact By Query By Business',
    props<{ payload: { page: number, size: number, query: string } }>()
)

export const createContacts = createAction(
    '[Contacs Page] Create Contacts',
    props< {contact: ContactModel, campaignId:string}>()
)

export const createContactsSuccess = createAction(
    '[Contacs Page] Create Contacts Success',
    props<{ contact: ContactModel }>()
)

export const bulkAddContacts = createAction(
    '[Contacs Page] Bulk Add Contacts',
    props<{ payload: { contact: ContactModel, campaignId: string }[] }>()
)

export const bulkAddContactsSuccess = createAction(
    '[Contacs Page] Bulk Add Contacts Success',
    props<{ result: ResultBulkAddModel }>()
)

export const editContact = createAction(
    '[Contacs Page] Edit Contact',
    props<{contact: ContactModel, campaignId:string}>()
)

export const editContactSuccess = createAction(
    '[Contacs Page] Edit Contact Success',
    props<{ contact: ContactModel }>()
)

export const deleteContact = createAction(
    '[Contacs Page] Delete Contact',
    props<{ contactId: string }>()
)

export const deleteContactSuccess = createAction(
    '[Contacs Page] Delete Contact Success',
    props<{ contactId: string }>()
)

export const setContactAdded = createAction(
    '[Contacs Page] Set Contact Added',
    props<{ contactAdded: boolean }>()
)


export const contactError = createAction(
    '[Contacs Page] Contact Error',
    props<{ error: string }>()
)

export const filterContactsByStatus = createAction(
    '[Reviews Page] Filter Contacts By Status',
    props<{ request: RequestModel }>()
)

export const filterContactsByStatusBusiness = createAction(
    '[Reviews Page] Filter Contacts By Status Business',
    props<{ request: RequestModel }>()
)

export const clearResultBulkAdd = createAction(
    '[Send Page] Clear Resul Bulk Add Uploaded',
)

export const exportDataContact = createAction(
    '[Contacs Page] Export  Data Contact',
    props<{ request: RequestModel }>()
)

export const exportDataContactSuccess = createAction(
    '[Contacs Page] Export  Data Contact Success',
    props<{ response: boolean }>()
)
export const setExportDataContact = createAction(
    '[Contacs Page] Set Export  Data Contact',
    props<{ isExporContact: boolean }>()
)

export const exportDataContactCount = createAction(
    '[Contacs Page] Export  Data Contact Count',
    props<{ request: RequestModel }>()
)

export const exportDataContactCountSuccess = createAction(
    '[Contacs Page] Export  Data Contact Count Success',
    props<{ data: { count: number } }>()
)